import request from '@/api/utils/request';
// import  * as index from '@/api/main/index';

export function getAllUserData(){
    return request({
        url: "/api/v1/user/userManagement/getAllUser",
        method: 'POST'
    });
}

export function createUser(data){
    return request({
        url: "/api/v1/user/signUp/",
        method: 'POST',
        data
    });
}

export function deleteUser(id){
    const data = {"userID": id};
    return request({
        url: "/api/v1/user/removeUser/",
        method: 'POST',
        data
    });
}

export function getUserInfo(id){
    const data = { "userID" : id};
    return request({
        url: "/api/v1/user/getUserInfoWithID/",
        method: 'POST',
        data
    });
}

export function changePassword(data){
    return request({
        url: "/api/v1/user/changePassword/",
        method: 'POST',
        data
    });
}

export function adminChangeUserPassword(data){
    return request({
        url: "/api/v1/user/changePwd/",
        method: 'POST',
        data
    });
}

export function unlockUser(data){
    return request({
        url: "/api/v1/user/unlockUser/",
        method: 'POST',
        data
    });
}

export function lockUser(data){
    return request({
        url: "/api/v1/user/lockUser/",
        method: 'POST',
        data
    });
}

export function getAllNormalUser(){
    return request({
        url: "/api/v1/user/getAllNormalUser/",
        method: 'POST',
    })
}